import { keyframes } from '@xstyled/styled-components';
import { Keyframes } from 'styled-components';

export const slideInRight = keyframes`
  0% {
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const slideToRight = keyframes`
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(1000px);
    opacity: 0;
  }
`;

export const slideInFwdBottom = keyframes`
  0% {
    transform: translateZ(-1400px) translateY(800px);
    opacity: 0;
  }
  100% {
    transform: translateZ(0) translateY(0);
    opacity: 1;
  }
`;

export const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const cardListAnimation = keyframes`
  from {
    transform: rotateY(90deg);
  }
  to {
    transform: rotateY(360deg);
  }
`;

export const shakeVerticalAnimation = keyframes`
0%,
  100% {
    transform: translateY(0);
  }
  10%,
  30%,
  50%,
  70% {
    transform: translateY(-8px);
  }
  20%,
  40%,
  60% {
    transform: translateY(8px);
  }
  80% {
    transform: translateY(6.4px);
  }
  90% {
    transform: translateY(-6.4px);
  }
`;

export const drillAnimation = keyframes`
  from {
    transform: scale(1);
    transform-origin: center center;
    animation-timing-function: ease-out;
  }
  10% {
    transform: scale(0.91);
    animation-timing-function: ease-in;
  }
  17% {
    transform: scale(0.98);
    animation-timing-function: ease-out;
  }
  33% {
    transform: scale(0.87);
    animation-timing-function: ease-in;
  }
  45% {
    transform: scale(1);
    animation-timing-function: ease-out;
  }
`;

export const slideInBottomAnimation = keyframes`
  0% {
    transform: translateY(1000px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const slideInTopAnimation = keyframes`
  0% {
    transform: translateY(-1000px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const settingButtonAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(90deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

export const videoButtonAnimation = keyframes`
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 0;
  }
  100% {
    -webkit-transform: scale(0.7);
            transform: scale(0.7);
            opacity: 0.5;
  }
`;

export const jumpAnimation = (
  start: string,
  middle: string,
  end: string
): Keyframes => {
  return keyframes`
      0% {
          margin-top: ${start};
      }
      50% {
          margin-top: ${middle};
      }
      100% {
          margin-top: ${end};
      }
`;
};

/** Soft opacity blink — once — for attention cues (e.g. Complete the steps). */
export const attentionPulse = keyframes`
  0% {
    opacity: 1;
  }
  20% {
    opacity: 0.55;
  }
  40% {
    opacity: 1;
  }
  60% {
    opacity: 0.55;
  }
  80%,
  100% {
    opacity: 1;
  }
`;
